module.exports = __webpack_public_path__ + "img/img-11.b9a83601.png";